export const SET_FILTRO_LISTAGEM_CLIENTE = "SET_FILTRO_LISTAGEM_CLIENTE";

export const setFiltroListagem = (filtroListagem) => ({
  type: SET_FILTRO_LISTAGEM_CLIENTE,
  filtroListagem,
});
